module.exports = __webpack_public_path__ + "img/20191219144509360截图20191219140451459.3311c1b2.jpg";